import React, { useState } from "react";
import { Link } from "react-router-dom";
// import TextEditor from "../../../feature-module/inventory/texteditor";
// import ImageWithBasePath from "../../img/imagewithbasebath";
import { DatePicker } from "antd";
import { Calendar, PlusCircle } from "feather-icons-react/build/IconComponents";
import PropTypes from "prop-types";
import { MinusCircle } from "react-feather";
import { Controller } from "react-hook-form";
import Select from "react-select";
import {
    LIST_BRANDS,
    LIST_CUSTOMER,
    LIST_PRODUCTS,
    LIST_WAREHOUSE,
} from "../../../apollo/queries";
import useCreateSale from "../../../controllers/useCreateSale";
import Dropdown from "../../../feature-module/components/Dropdown";
import ErrorMessage from "../../../feature-module/components/errorMessage";
import InputField from "../../../feature-module/components/InputField";
import { getSelectedStoreDetails } from "../../../utils/helperFunctions";
import ImageWithBasePath from "../../img/imagewithbasebath";

const AddSales = ({ id, refetch, downloadInvoice }) => {

    const { values, functions } = useCreateSale(refetch, downloadInvoice, id);

    const [selectedWarehouse, setSelectedWarehouse] = useState(null);
    const [selectedBrand, setSelectedBrand] = useState(null);

    const handleReset = () => {
        functions.setProductArray([]);
        setSelectedBrand(null)
        setSelectedWarehouse(null)
        functions.onCancel();
    };

    const handleChangeWarehouse = (selectedOption) => {
        setSelectedWarehouse(selectedOption);
    };

    const handleChangeBrand = (selectedOption) => {
        setSelectedBrand(selectedOption);
    };

    const handleChangeProduct = (selectedOption) => {
        functions.setProductArray((prevArray) => {
            const existingProductIndex = prevArray.findIndex(
                (product) => product.product_id === selectedOption.value
            );

            if (existingProductIndex !== -1) {
                // Product already exists, increase its quantity
                return prevArray.map((product, index) =>
                    index === existingProductIndex
                        ? { ...product, quantity: String(Number(product.quantity) + 1) }
                        : product
                );
            } else {
                // Add new product

                return [
                    ...prevArray,
                    {
                        product_id: selectedOption.value,
                        productName: selectedOption?.label,
                        images: selectedOption?.images,
                        quantity: "1",
                        price: selectedOption.price,
                    },
                ];
            }
        });
    };

    // const status = [
    //     { value: "Pending", label: "Pending" },
    //     { value: "Confirmed", label: "Confirmed" },
    // ];

    const handleQuantityChange = (index, action, e) => {
        e.preventDefault();
        const updatedArray = [...values.productArray];
        let currentIndex = updatedArray[index];

        currentIndex.quantity = parseInt(currentIndex.quantity, 10);
        if (action === "increment") {
            currentIndex.quantity += 1;
        } else if (action === "decrement" && currentIndex.quantity > 1) {
            currentIndex.quantity -= 1;
        }
        updatedArray[index] = currentIndex;
        functions.setProductArray(updatedArray);
    };

    const handleDeleteItem = (index) => {
        functions.setProductArray((prevArray) => {
            return prevArray.filter((item, i) => i !== index);
        });
    };

    const handleInputChange1 = (event, i) => {
        const value = parseInt(event.target.value, 10);
        if (!isNaN(value) && value >= 1) {
            values.productArray[i].quantity = event.target.value;
            functions.setProductArray([...values.productArray]);
        } else {
            values.productArray[i].quantity = "";
            functions.setProductArray([...values.productArray]);
        }
    };

    const handlePriceChange = (event, i) => {
        const value = parseFloat(event.target.value);
        if (!isNaN(value) && value >= 1) {
            values.productArray[i].price = event.target.value;
            functions.setProductArray([...values.productArray]);
        } else {
            values.productArray[i].price = "";
            functions.setProductArray([...values.productArray]);
        }
    };

    return (
        <div>
            {/*Add Quotation */}
            <div
                className="modal fade"
                id="add-sales-new"
                data-bs-backdrop="static"
                data-bs-keyboard="false"
                tabIndex="-1"
            >
                <div className="modal-dialog purchase stock-adjust-modal">
                    <div className="modal-content">
                        <div className="page-wrapper-new p-0">
                            <div className="content">
                                <div className="modal-header border-0 custom-modal-header">
                                    <div className="page-title">
                                        <h4>Add New Sale</h4>
                                    </div>
                                    <button
                                        type="button"
                                        className="close"
                                        data-bs-dismiss="modal"
                                        aria-label="Close"
                                        onClick={handleReset}
                                    >
                                        <span aria-hidden="true">×</span>
                                    </button>
                                </div>
                                {
                                    values.loading_sale ?
                                        <div className="d-flex justify-content-center mb-4">
                                            <div className="spinner-border text-primary me-1" role="status">
                                                <span className="sr-only">Loading...</span>
                                            </div>
                                        </div> :
                                        <div className="modal-body custom-modal-body">
                                            {/* <form onSubmit={handleCLickAdd}> */}
                                            <div className="row">
                                                <div className="col-lg-6 col-md-6 col-sm-12">
                                                    <Controller
                                                        name="customer_id"
                                                        control={values.control}
                                                        rules={{ required: "Customer is required" }}
                                                        render={({ field }) => (
                                                            <Dropdown
                                                                field={field}
                                                                query={LIST_CUSTOMER}
                                                                dataKey="listCustomer"
                                                                variables={{
                                                                    storeId: getSelectedStoreDetails("id"),
                                                                }}
                                                                label="Customer Name"
                                                                required={true}
                                                                placeholder="Select a Customer"
                                                            // onChange={handleChangeCustomer}
                                                            />
                                                        )}
                                                    />
                                                    <ErrorMessage
                                                        error={values.errors?.customer_id?.message}
                                                    />
                                                </div>
                                                <div className="col-lg-3 col-md-3 col-sm-12">
                                                    <div className="input-blocks">
                                                        <label>
                                                            Date <span>*</span>
                                                        </label>
                                                        <div className="input-groupicon calender-input mb-2">
                                                            <Calendar className="info-img" />
                                                            <Controller
                                                                name="sale_date"
                                                                control={values.control}
                                                                rules={{ required: "Date is required" }}
                                                                render={({ field }) => (
                                                                    <DatePicker
                                                                        {...field}
                                                                        required={true}
                                                                        name="sale_date"
                                                                        onChange={(date) => {
                                                                            console.log("date", date);
                                                                            field.onChange(date);
                                                                        }}
                                                                        selected={field.value}
                                                                        type="date"
                                                                        className="filterdatepicker"
                                                                        dateFormat="dd-MM-yyyy"
                                                                        placeholder="Choose Quotation Date"
                                                                    />
                                                                )}
                                                            />
                                                        </div>
                                                        <ErrorMessage
                                                            error={values.errors?.sale_date?.message}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-3 col-md-3 col-sm-12">
                                                    <div className="input-blocks">
                                                        <Controller
                                                            name="reference_no"
                                                            control={values.control}
                                                            render={({ field }) => (
                                                                <InputField
                                                                    name="reference_no"
                                                                    label="Reference Number"
                                                                    type="text"
                                                                    placeholder="Enter Reference Number"
                                                                    {...field}
                                                                />
                                                            )}
                                                        />
                                                        <ErrorMessage
                                                            error={values.errors?.reference_no?.message}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-lg-6 col-md-6 col-sm-12">
                                                    <Controller
                                                        name="warehouse_id"
                                                        control={values.control}
                                                        rules={{ required: "Warehouse is required" }}
                                                        render={({ field }) => (
                                                            <Dropdown
                                                                query={LIST_WAREHOUSE}
                                                                dataKey="listWarehouse"
                                                                variables={{
                                                                    storeId: getSelectedStoreDetails("id"),
                                                                }}
                                                                label="Warehouse"
                                                                required={true}
                                                                placeholder="Select a Warehouse"
                                                                field={field}
                                                                onChange={handleChangeWarehouse}
                                                            />
                                                        )}
                                                    />
                                                    <ErrorMessage
                                                        error={values.errors?.warehouse_id?.message}
                                                    />
                                                </div>
                                                <div className="col-lg-6 col-md-6 col-sm-12">
                                                    <Dropdown
                                                        query={LIST_BRANDS}
                                                        variables={{
                                                            storeId: getSelectedStoreDetails("id"),
                                                        }}
                                                        dataKey={"listBrand"}
                                                        label="Brand"
                                                        placeholder="Select a Brand"
                                                        field={{ value: selectedBrand?.value }}
                                                        onChange={handleChangeBrand}
                                                        isClearable
                                                    />
                                                </div>
                                                <div className="col-lg-12 col-md-12 col-sm-12">
                                                    <div className="mb-2">
                                                        <Controller
                                                            name="product_id"
                                                            control={values.control}
                                                            render={({ field }) =>
                                                                selectedWarehouse ? (
                                                                    <Dropdown
                                                                        query={LIST_PRODUCTS}
                                                                        dataKey="listProduct"
                                                                        variables={{
                                                                            storeId: getSelectedStoreDetails("id"),
                                                                            warehouseId: selectedWarehouse?.value,
                                                                            customerId: values?.selected_customer || null,
                                                                            brandId: selectedBrand?.value || null,
                                                                        }}
                                                                        label="Product"
                                                                        placeholder="Select a Product"
                                                                        field={field}
                                                                        onChange={handleChangeProduct}
                                                                    />
                                                                ) : (
                                                                    <>
                                                                        <label>Product</label>
                                                                        <Select
                                                                            classNamePrefix="react-select"
                                                                            placeholder="Select a Product"
                                                                        />                                                            </>
                                                                )
                                                            }
                                                        />
                                                    </div>
                                                    <ErrorMessage
                                                        error={values.errors?.product_id?.message}
                                                    />
                                                </div>
                                                {/* <div className="col-lg-4 col-md-6 col-sm-12">
                        <div className="input-blocks"> */}
                                                {/* <Controller
                            name="quantity"
                            control={values.control}
                            // rules={{ required: "Quantity is required" }}
                            render={({ field }) => ( */}
                                                {/* <InputField
                            required={true}
                            name="quantity"
                            label="Quantity"
                            type="number"
                            placeholder="Enter Quantity"
                            value={formFields?.quantity}
                            // {...field}
                            // onKeyDown={handleKeyDown}
                            onChange={handleInputChange}
                          /> */}
                                                {/* )}
                          /> */}
                                                {/* <ErrorMessage
                            error={values.errors?.quantity?.message}
                          /> */}
                                                {/* </div>
                      </div> */}
                                            </div>
                                            {/* <div className="row">
                    <div
                      className="col-lg-12"
                      style={{
                        textAlign: "right",
                        margin: "10px 0px 20px 0px",
                      }}
                    >
                      <button type="submit" className="btn btn-submit">
                        Add
                      </button>
                    </div>
                  </div> */}
                                            {/* </form> */}
                                            <div className="row">
                                                <div className="col-lg-12">
                                                    <div className="modal-body-table">
                                                        <div className="table-responsive">
                                                            <table className="table datanew">
                                                                <thead>
                                                                    <tr>
                                                                        <th className="p-4">S. No</th>
                                                                        <th className="p-4">Product</th>
                                                                        <th className="p-4 text-center">Qty</th>
                                                                        <th className="p-4 ml-20">Unit Cost</th>
                                                                        <th className="p-4">Total Cost</th>
                                                                        <th className="p-4">Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {values.productArray?.length > 0 ? (
                                                                        <>
                                                                            {values.productArray?.map((x, i) => (
                                                                                <tr
                                                                                    key={i}
                                                                                    style={{ background: "#ffffff" }}
                                                                                >
                                                                                    <td className="p-4">{i + 1}</td>
                                                                                    <td className="p-4">
                                                                                        <div className="productimgname">
                                                                                            <Link
                                                                                                to="#"
                                                                                                className="product-img stock-img"
                                                                                            >
                                                                                                <ImageWithBasePath
                                                                                                    alt=""
                                                                                                    src={
                                                                                                        x.images?.length > 0
                                                                                                            ? x.images
                                                                                                            : "assets/img/product/noimage.png"
                                                                                                    }
                                                                                                    isApiImage={
                                                                                                        x.images?.length > 0
                                                                                                            ? true
                                                                                                            : false
                                                                                                    }
                                                                                                />
                                                                                                {/* <ImageWithBasePath
                                        src="assets/img/products/stock-img-02.png"
                                        alt="product"
                                      /> */}
                                                                                            </Link>
                                                                                            <Link to="#"> {x.productName}</Link>
                                                                                        </div>
                                                                                    </td>
                                                                                    <td
                                                                                        className="p-4 text-center"
                                                                                        style={{ width: "100px" }}
                                                                                    >
                                                                                        <div className="product-quantity">
                                                                                            <span
                                                                                                className="quantity-btn"
                                                                                                onClick={(e) => {
                                                                                                    if (x.quantity >= 1) {
                                                                                                        handleQuantityChange(
                                                                                                            i,
                                                                                                            "decrement",
                                                                                                            e
                                                                                                        );
                                                                                                    }
                                                                                                }}
                                                                                            >
                                                                                                <MinusCircle />
                                                                                            </span>
                                                                                            <input
                                                                                                value={x.quantity}
                                                                                                onChange={(e) =>
                                                                                                    handleInputChange1(e, i)
                                                                                                }
                                                                                                type="number"
                                                                                                className="quntity-input"
                                                                                            />
                                                                                            <span
                                                                                                className="quantity-btn"
                                                                                                onClick={(e) =>
                                                                                                    handleQuantityChange(
                                                                                                        i,
                                                                                                        "increment",
                                                                                                        e
                                                                                                    )
                                                                                                }
                                                                                            >
                                                                                                <PlusCircle className="plus-circle" />
                                                                                            </span>
                                                                                        </div>
                                                                                    </td>
                                                                                    <td className="p-4 text-center">
                                                                                        <div
                                                                                            className="product-quantity"
                                                                                            style={{ width: "100px" }}
                                                                                        >
                                                                                            <input
                                                                                                value={x.price}
                                                                                                onChange={
                                                                                                    (e) => {
                                                                                                        console.log("eee", e);
                                                                                                        handlePriceChange(e, i);
                                                                                                    }
                                                                                                    // handleInputChange1(e, i)
                                                                                                }
                                                                                                type="number"
                                                                                                className="quntity-input"
                                                                                                style={{ width: "80px" }}
                                                                                            />
                                                                                        </div>
                                                                                    </td>
                                                                                    <td className="p-4">
                                                                                        ${(x.quantity * x.price).toFixed(2)}
                                                                                    </td>
                                                                                    <td>
                                                                                        <div className="action-table-data">
                                                                                            <div className="edit-delete-action">
                                                                                                <Link
                                                                                                    className="confirm-text p-2"
                                                                                                    to="#"
                                                                                                    onClick={() =>
                                                                                                        handleDeleteItem(i)
                                                                                                    }
                                                                                                >
                                                                                                    <i
                                                                                                        data-feather="trash-2"
                                                                                                        className="feather-trash-2"
                                                                                                    ></i>
                                                                                                </Link>
                                                                                            </div>
                                                                                        </div>
                                                                                    </td>
                                                                                </tr>
                                                                            ))}
                                                                        </>
                                                                    ) : (
                                                                        <tr>
                                                                            <td
                                                                                colSpan={6}
                                                                                className="p-4"
                                                                                style={{ textAlign: "center" }}
                                                                            >
                                                                                No Product
                                                                            </td>
                                                                        </tr>
                                                                    )}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-lg-4 col-md-6 col-sm-12">
                                                        <div className="input-blocks mb-3">
                                                            <Controller
                                                                name="sale_tax"
                                                                control={values.control}
                                                                rules={{ required: "Tax is required" }}
                                                                render={({ field }) => (
                                                                    <InputField
                                                                        required={true}
                                                                        label="Tax"
                                                                        type="text"
                                                                        placeholder="Enter Tax"
                                                                        value={values.control}
                                                                        {...field}
                                                                    />
                                                                )}
                                                            />
                                                            <ErrorMessage
                                                                error={values.errors?.sale_tax?.message}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-4 col-md-6 col-sm-12">
                                                        <div className="input-blocks mb-3">
                                                            <Controller
                                                                name="discount"
                                                                control={values.control}
                                                                rules={{
                                                                    required: "Discount is required",
                                                                }}
                                                                render={({ field }) => (
                                                                    <InputField
                                                                        required={true}
                                                                        label="Discount"
                                                                        type="text"
                                                                        placeholder="Enter Discount"
                                                                        value={values.control}
                                                                        {...field}
                                                                    />
                                                                )}
                                                            />
                                                            <ErrorMessage
                                                                error={values.errors?.discount?.message}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-4 col-md-6 col-sm-12">
                                                        <div className="input-blocks mb-3">
                                                            <Controller
                                                                name="shipping"
                                                                control={values.control}
                                                                rules={{
                                                                    required: "Shipping is required",
                                                                }}
                                                                render={({ field }) => (
                                                                    <InputField
                                                                        required={true}
                                                                        label="Shipping"
                                                                        type="text"
                                                                        placeholder="Enter Shipping"
                                                                        value={values.control}
                                                                        {...field}
                                                                    />
                                                                )}
                                                            />
                                                            <ErrorMessage
                                                                error={values.errors?.shipping?.message}
                                                            />
                                                        </div>
                                                    </div>
                                                    {/* <div className="col-lg-3 col-md-6 col-sm-12">
                                                <div className="input-blocks mb-3">
                                                    <label>
                                                        Status <span>*</span>
                                                    </label>
                                                    <Controller
                                                        name="status"
                                                        control={values.control}
                                                        rules={{ required: "Status is required" }}
                                                        render={({ field }) => (
                                                            <Select
                                                                classNamePrefix="react-select"
                                                                className="mb-2"
                                                                options={status}
                                                                placeholder="Select Status"
                                                                value={status.find(
                                                                    (item) => item.value === field?.value
                                                                )}
                                                                onChange={(selectedOption) =>
                                                                    field.onChange(selectedOption.value)
                                                                }
                                                            />
                                                        )}
                                                    />
                                                    <ErrorMessage
                                                        error={values.errors?.status?.message}
                                                    />
                                                </div>
                                            </div> */}
                                                </div>
                                            </div>
                                            {/* <div className="col-lg-12">
                      <div className="input-blocks summer-description-box">
                        <label>Description</label>
                        <div id="summernote" />
                        <TextEditor />
                      </div>
                    </div> */}
                                            <div className="modal-footer-btn">
                                                <button
                                                    type="button"
                                                    className="btn btn-cancel me-2"
                                                    data-bs-dismiss="modal"
                                                    onClick={handleReset}
                                                >
                                                    Cancel
                                                </button>
                                                <Link
                                                    onClick={functions.onSubmit}
                                                    to="#"
                                                    className="btn btn-submit"
                                                    isabled={values.loading}
                                                >
                                                    {values.loading ? (
                                                        <>
                                                            <span className="spinner-border spinner-border-sm me-2"></span>
                                                            Submit
                                                        </>
                                                    ) : (
                                                        "Submit"
                                                    )}
                                                </Link>
                                            </div>
                                        </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

AddSales.propTypes = {
    refetch: PropTypes.func,
    downloadInvoice: PropTypes.func,
    id: PropTypes.number
};

export default AddSales;
